import { pemEncode, toBase64 } from '../core/bytes/encoding';
import { isDesktop, saveFile } from './state/desktop';

export function downloadBlob(filename: string, data: Uint8Array | string, mime: string): void {
  if (isDesktop()) {
    void saveFile(filename, data, mime); // the shell shows a native save dialog
    return;
  }
  const blob = new Blob([data as BlobPart], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    URL.revokeObjectURL(url);
    a.remove();
  }, 0);
}

export const downloadDer = (name: string, der: Uint8Array): void => downloadBlob(name.endsWith('.der') ? name : `${name}.der`, der, 'application/pkix-cert');
export const downloadPem = (name: string, der: Uint8Array | Uint8Array[], label = 'CERTIFICATE'): void =>
  downloadBlob(name.endsWith('.pem') ? name : `${name}.pem`, (Array.isArray(der) ? der : [der]).map((d) => pemEncode(d, label)).join(''), 'application/x-pem-file');

export const base64Of = toBase64;
